import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme, useMediaQuery } from '@mui/material';

import {
  getActionIconButtonSize,
  Icon,
  MarginButton,
  MarginIconButton,
} from './inline-base-styles';

interface HideButtonProps {
  text?: string;
  withoutText?: boolean;
  hideHook: () => void;
  children?: React.ReactNode;
}

export const HideButton: React.FC<HideButtonProps> = ({
  text,
  withoutText,
  hideHook,
}) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  if (isMobile || withoutText) return <ButtonWithoutText hideHook={hideHook} />;
  return <ButtonWithText hideHook={hideHook} text={text} />;
};

const ButtonWithText: React.FC<
  Pick<HideButtonProps, 'hideHook' | 'text'> & { children?: React.ReactNode }
> = ({ text, hideHook, children }) => {
  const { t } = useTranslation(['translation', 'admin']);

  return (
    <MarginButton
      variant="contained"
      size="small"
      onClick={() => hideHook()}
      startIcon={<Icon icon={faEyeSlash} size="sm" />}
    >
      <span className="d-none d-lg-inline">
        {String(t(text || 'global.buttons.hide'))}
      </span>
    </MarginButton>
  );
};

const ButtonWithoutText: React.FC<Pick<HideButtonProps, 'hideHook'>> = ({
  hideHook,
}) => {
  const dimension = getActionIconButtonSize('small');

  return (
    <MarginIconButton
      color="primary"
      size="small"
      onClick={() => hideHook()}
      style={{
        width: dimension,
        minWidth: dimension,
        maxWidth: dimension,
        height: dimension,
        minHeight: dimension,
        maxHeight: dimension,
        marginBottom: '0',
        padding: '0',
      }}
    >
      <Icon icon={faEyeSlash} size="sm" />
    </MarginIconButton>
  );
};
